<template>
    <div class="popup rd-dialog rd-payment skin-order-dialog">
        <van-popup v-model="show" @click-overlay="close">
            <div class="content">
                <div class="header">
                    <OrderHeading :order="detail" :step="step" compact />
                    <button type="button" class="close" :aria-label="$t('displayUi.Close')" @click="close"><RefreshIcon name="close"/></button>
                </div>
                <div class="main-content">
                    <OrderHeading :order="detail" :step="step" />
                    <div class="WaitingForPayment">{{ $te('skinDetails.orderStates.' + detail.rechargeOrderState) ? $t('skinDetails.orderStates.' + detail.rechargeOrderState) : detail.rechargeOrderState }}</div>
                    <div v-if="detail.usdtAmt" class="money" @click="onCopy(detail.usdtAmt + 'USDT')">
                        <span>{{ detail.usdtAmt }}USDT</span>
                        <span class="iconfont icon-fuzhiwenjian"></span>
                    </div>
                    <div v-else class="money" @click="onCopy(CurrencyType + detail.orderAmt)">
                        <span class="val">{{ CurrencyType }}{{ detail.orderAmt }}</span>
                        <span class="iconfont icon-fuzhiwenjian"></span>
                    </div>
                    <div v-if="detail.usdtAmt" class="exchangeRate">
                        <span>{{ $t("DepositDetails.ExchangeRate") + ' U1 : ' + CurrencyType + (detail.usdtRate || 0) + '，'
                        }}</span>
                        <span>{{ $t("deposit.Deposit") }}</span>
                        <span class="val">{{ CurrencyType }}{{ detail.orderAmt }}</span>
                    </div>
                    <div class="bills">
                        <div class="bills-item">
                            <div>{{ $t("DepositDetails.DepositMethod") }}</div>
                            <div>{{ detail.payChannelType }}</div>
                        </div>
                        <div class="bills-item">
                            <div>{{ $t("DepositDetails.CreationTime") }}</div>
                            <div>{{ detail.createTime }}</div>
                        </div>
                        <div class="bills-item">
                            <div>{{ $t("DepositDetails.OrderNumber") }}</div>
                            <div @click="onCopy(detail.orderNo)">
                                <div class="val">{{ detail.orderNo }}</div>
                                <span class="iconfont icon-fuzhiwenjian"></span>
                            </div>
                        </div>
                        <div v-if="detail.usdtAmt" class="bills-item">
                            <div>{{ $t("DepositDetails.TransactionRemark") }}</div>
                            <div @click="onCopy(detail.memberInfoId)">
                                <div class="val">{{ detail.memberInfoId }}</div>
                                <span class="iconfont icon-fuzhiwenjian"></span>
                            </div>
                        </div>
                        <div v-if="detail.cashAddress && detail.rechargeOrderState == 'WaitPay' && step == 1"
                            class="bills-item qrcode-box">
                            <div style="width: 1.38rem;" class="qrcode-wrap">
                                <img class="qrcode-icon" src="@/assets/deposit/icon_Transfer.png" />
                                <div class="qrcode-canvas">
                                    <canvas ref="qrcodeCanvas"></canvas>
                                </div>
                            </div>
                        </div>
                        <div v-if="detail.cashAddress && detail.rechargeOrderState == 'WaitPay' && step == 1"
                            class="bills-item qrcode-item">
                            <div>TRC-20：</div>
                            <div @click="onCopy(detail.cashAddress)">
                                <div class="val">{{ detail.cashAddress }}</div>
                                <span class="iconfont icon-fuzhiwenjian"></span>
                            </div>
                        </div>
                        <div v-else-if="detail.usdtAmt" class="bills-item">
                            <div>TRC-20</div>
                            <div @click="onCopy(detail.cashAddress)">
                                <div class="val">{{ detail.cashAddress }}</div>
                                <span class="iconfont icon-fuzhiwenjian"></span>
                            </div>
                        </div>
                        <div v-if="detail.paymentCode && detail.usdtAmt" class="bills-item">
                            <div>{{ $t("DepositDetails.hashAddress") }}</div>
                            <div>
                                <div class="line val"
                                    @click="onNavTo(('https://tronscan.io/#/transaction/' + detail.paymentCode), 'href')">
                                    {{ detail.paymentCode }}</div>
                                <span class="iconfont icon-fuzhiwenjian"
                                    @click="onCopy('https://tronscan.io/#/transaction/' + detail.paymentCode)"></span>
                            </div>
                        </div>
                    </div>
                    <div v-if="((detail.rechargeOrderState == 'WaitPay' && step == 2) || detail.rechargeOrderState == 'Paying' || detail.rechargeOrderState == 'Fail') && detail.usdtAmt"
                        class="page_title">{{ $t('DepositDetails.hashAddress') }}</div>
                    <div v-if="((detail.rechargeOrderState == 'WaitPay' && step == 2) || detail.rechargeOrderState == 'Paying' || detail.rechargeOrderState == 'Fail') && detail.usdtAmt"
                        class="page_input">
                        <a-input v-model="hashAddress"
                            :placeholder="$t('DepositDetails.pleasetEnterHashAddress')"></a-input>
                    </div>
                    <div v-if="detail.usdtAmt" class="tips">
                        <div>{{ $t("DepositDetails.DepositTips1") }}</div>
                        <div>{{ $t("DepositDetails.DepositTips2") }}</div>
                        <div>{{ $t("DepositDetails.DepositTips3") }}</div>
                    </div>
                </div>
                <div v-if="detail.rechargeOrderState == 'WaitPay' && step == 1 && detail.usdtAmt" class="btns">
                    <div class="btn cancel-btn" @click="onCancel">{{ $t("DepositDetails.cancelBtn") }}</div>
                    <div class="btn confirm-btn" @click="onConfirm">{{ $t("DepositDetails.TransferredBtn") }}</div>
                </div>
                <div v-if="detail.rechargeOrderState == 'WaitPay' && step == 2 && detail.usdtAmt" class="btns">
                    <div class="btn confirm-btn" @click="onContinue">{{ $t("DepositDetails.ContinueBtn") }}</div>
                </div>
                <div v-if="(detail.rechargeOrderState == 'Paying' || detail.rechargeOrderState == 'Fail') && detail.usdtAmt" class="btns">
                    <div class="btn confirm-btn" @click="onContinue">{{ $t("DepositDetails.ContinueBtn") }}</div>
                </div>
            </div>
        </van-popup>
        <confirmPopup ref="confirmPopup" :orderNo="detail.orderNo" @close="close"></confirmPopup>
    </div>
</template>

<script>
import { Toast } from 'vant'
import QRCode from 'qrcode'
import confirmPopup from './confirmPopup.vue'
import { WriteUsdtDepositOrderHash } from '@/api/deposit'
export default {
    name: 'depositDetail',
    components: { confirmPopup },
    data() {
        return {
            show: false,
            isFocus: 0,
            hashAddress: '',
            canCallHandleRecharge: true,
            detail: {},
            step: 1
        }
    },
    props: {
        details: {
            type: Object,
            default: () => {
                return {
                    createTime: '',
                    dataGrandComputeState: '',
                    firstOrManyType: '',
                    fistRechargeRecommenderState: '',
                    giftAmt: 0,
                    id: '',
                    ipAddress: '',
                    memberInfoId: '',
                    note: '',
                    orderAmt: 0,
                    orderNo: '',
                    payChannelId: '',
                    payChannelType: '',
                    payFailDec: null,
                    payTime: null,
                    payUrl: null,
                    paymentCode: '',
                    realityAmt: 0,
                    receiveTime: null,
                    rechargeLevelState: '',
                    rechargeOrderState: '',
                    recommenderMemberInfoId: '',
                    salesPersonId: '',
                    updateTime: '',
                    usdtAmt: 0,
                    usdtRate: 0,
                    userAgent: null,
                    yesNoType: '',
                    hashAddress: ''
                }
            }
        }
    },
    methods: {
        close() {
            this.show = false
            this.step = 1
        },
        open() {
            this.show = true
            this.hashAddress = ''
            this.$nextTick(() => {
                this.detail = this.details
                if (this.detail.cashAddress) {
                    this.$nextTick(() => {
                        this.generateQRCode(this.detail.cashAddress)
                    })
                }
            })
        },
        generateQRCode(link) {
            if (!this.$refs.qrcodeCanvas) return
            QRCode.toCanvas(this.$refs.qrcodeCanvas, link, error => {
                if (error) console.error(error)
            })
        },
        onCancel() {
            this.$refs.confirmPopup.open()
        },
        onConfirm() {
            this.step = 2
        },
        onContinue() {
            if (this.canCallHandleRecharge) {
                this.canCallHandleRecharge = false
                if (!this.hashAddress) {
                    Toast(this.$t('DepositDetails.pleasetEnterHashAddress'))
                    this.canCallHandleRecharge = true
                    return
                }
                const params = {
                    memberHash: this.hashAddress,
                    orderNo: this.detail.orderNo
                }
                WriteUsdtDepositOrderHash(params).then(res => {
                    Toast(res.message)
                    if (res.code === 0 && !this.canCallHandleRecharge) {
                        this.$emit('onContinue')
                        this.close()
                    }
                }).finally(() => {
                    this.canCallHandleRecharge = true
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

$deposit-detail-divider-color: $border-component-dark-color;
$deposit-detail-input-bg: linear-gradient(180deg, rgba($bg-component-panel-deep-color, .96) 0%, rgba($bg-component-disabled-deep-color, .98) 100%);
$deposit-detail-input-text: $font-component-gold-cream-color;
$deposit-detail-input-border: rgba($font-component-gold-base-color, .65);
$deposit-detail-input-focus-border: $font-component-gold-strong-color;
$deposit-detail-input-focus-shadow: 0 0 0 0.03rem rgba($font-component-gold-strong-color, .18);
$deposit-detail-input-placeholder: rgba($font-component-gold-warm-color, .62);
$deposit-detail-extra-color: $font-component-hot-soft-color;
$deposit-detail-soft-extra-color: $font-component-gold-ivory-soft-color;
$deposit-detail-tips-color: $font-component-gold-soft-color;
$deposit-detail-footer-bg: $bg-component-red-deep-gradient-color;
$deposit-detail-cancel-border: $font-component-gold-base-color;
$deposit-detail-cancel-text: $font-component-gold-warm-color;
$deposit-detail-cancel-bg: rgba($font-component-gold-pale-color, .08);
$deposit-detail-confirm-text: $font-btn-color;
$deposit-detail-shell-highlight: radial-gradient(circle at 20% 0, rgba($font-component-hot-soft-color, .14) 0, rgba($font-component-hot-soft-color, 0) 30%);
$deposit-detail-shell-overlay: linear-gradient(180deg, rgba($font-title-color, .04) 0, rgba($font-title-color, 0) .24rem);
$deposit-detail-shell-border: rgba($font-component-hot-color, .24);
$deposit-detail-shell-shadow: 0 .18rem .36rem rgba($bg-shell-color, .3);
$deposit-detail-highlight: $font-component-hot-soft-color;
$deposit-detail-muted: $font-component-info-muted-color;
$deposit-detail-muted-border: rgba($font-component-hot-color, .3);
$deposit-detail-themed-input-overlay: linear-gradient(180deg, rgba($font-title-color, .03) 0%, rgba($font-title-color, 0) .12rem);
$deposit-detail-cancel-btn-bg: linear-gradient(180deg, rgba($bg-component-panel-deep-color, .96) 0%, rgba($bg-component-disabled-deep-color, .98) 100%);
$deposit-detail-confirm-btn-bg: $bg-component-danger-color;
$deposit-detail-button-shadow: 0 .06rem .14rem rgba($bg-shell-color, .22);
.popup {
    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .content {
            border-radius: 12px;
            background-color: $bg-popup-color;
            width: 500px;
            max-height: 80vh;
            height: 700px;
            box-sizing: border-box;
            position: relative;
            overflow: auto;
            padding-bottom: 30px;
            display: flex;
            flex-direction: column;
        }

        .header {
            display: flex;
            height: 1rem;
            padding-left: .46rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: .1rem;

            &>div:first-child {
                font-size: .32rem;
                font-weight: bold;
                color: $font-color;
            }

            .close {
                color: $font-component-muted-color;
                font-size: .36rem;
                font-weight: bold;
                height: 1rem;
                width: 1rem;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
            }
        }

        .main-content {
            padding: 0 .28rem;
            flex: 1;
            padding-bottom: 1rem;
            overflow: auto;

            .time-icon {
                width: 1rem;
                height: 1rem;
                margin: 0 auto;
                display: block;
            }

            .WaitingForPayment {
                color: $font-component-gold-bright-color;
                font-size: .24rem;
                text-align: center;
                margin-top: .28rem;
            }

            .money {
                display: flex;
                align-items: center;
                justify-content: center;
                color: $font-color;
                font-size: .52rem;

                &>span:last-child {
                    font-size: .42rem;
                    margin-left: .2rem;
                    color: $font-component-gold-bright-color;
                }
            }

            .exchangeRate {
                display: flex;
                align-items: center;
                justify-content: center;
                color: $font-component-pale-color;

                .val {
                    color: $font-component-gold-bright-color;
                    margin-left: .08rem;
                }
            }

            .bills {
                border-top: .01rem dashed $deposit-detail-divider-color;
                border-bottom: .01rem dashed $deposit-detail-divider-color;
                padding: .2rem 0;
                margin: .24rem 0;

                .bills-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: .1rem 0;

                    &>div {
                        width: 50%;
                        color: $font-component-rose-muted-color;
                        font-size: .24rem;
                        line-height: .32rem;
                        text-align: left;
                    }

                    &>div:last-child {
                        font-size: .22rem;
                        color: $font-color;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        line-height: .28rem;
                        width: 50%;
                        text-align: right;

                        .iconfont {
                            color: $font-component-hot-strong-color;
                            margin-left: .15rem;
                        }

                        .line {
                            color: $font-component-hot-strong-color;
                        }

                        .val {
                            width: calc(100% - .4rem);
                            word-break: break-all;
                        }
                    }

                    &.qrcode-box {
                        justify-content: center;
                        border-top: .01rem dashed $font-component-field-color;
                        padding-top: .28rem;
                        margin-top: .22rem;

                        .qrcode-wrap {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;

                            .qrcode-icon {
                                width: .58rem;
                                height: .58rem;
                                border-radius: 50%;
                                margin-bottom: .2rem;
                            }

                            .qrcode-canvas {
                                background: $font-color;
                                width: 1.72rem;
                                height: 1.72rem;
                                overflow: hidden;
                                position: relative;

                                canvas {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    width: 115% !important;
                                    height: 115% !important;
                                }
                            }
                        }
                    }

                    &.qrcode-item {
                        justify-content: center;

                        &>div:first-child {
                            span-align: right;
                            width: auto;
                        }

                        .val {
                            span-align: left;
                        }
                    }
                }
            }

            .page_title {
                color: $font-color;
                font-weight: bold;
                font-size: .28rem;
                padding-top: .08rem;
                padding-bottom: .2rem;
            }

            .page_input {
                ::v-deep input::-webkit-outer-spin-button {
                    -webkit-appearance: none;
                }

                ::v-deep input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                }

                ::v-deep input[type='number'] {
                    -moz-appearance: textfield;
                }

                ::v-deep .ant-input {
                    background: $deposit-detail-input-bg !important;
                    border-radius: 0.14rem;
                    font-size: 0.22rem;
                    height: 0.85rem;
                    padding: 0px 0.24rem !important;
                    color: $deposit-detail-input-text;
                    border: .02rem solid $deposit-detail-input-border !important;
                    padding-right: 2.8rem !important;

                    &:focus {
                        background-color: transparent;
                        border-color: $deposit-detail-input-focus-border !important;
                        box-shadow: $deposit-detail-input-focus-shadow;
                    }

                    &::-webkit-input-placeholder {
                        /* WebKit browsers */
                        font-size: .22rem;
                        color: $deposit-detail-input-placeholder;
                        opacity: .7;
                        font-weight: 100;
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        font-size: .22rem;
                        color: $deposit-detail-input-placeholder;
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        font-size: .22rem;
                        color: $deposit-detail-input-placeholder;
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10+ */
                        font-size: .22rem;
                        color: $deposit-detail-input-placeholder;
                    }

                }

                ::v-deep .ant-input-suffix {
                    .extra {
                        color: $deposit-detail-extra-color;
                        padding-right: .24rem;
                    }

                    .noBonus {
                        color: $deposit-detail-soft-extra-color;
                        padding-right: .24rem;
                    }
                }
            }

            .tips {
                color: $deposit-detail-tips-color;
                font-size: .22rem;
                padding-bottom: .1rem;
                text-align: left;
            }
        }

        .btns {
            width: 100%;
            position: absolute;
            height: .9rem;
            left: 0;
            bottom: 0;
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
            padding: 0 .18rem;
            background: $deposit-detail-footer-bg;
            padding-top: .1rem;

            .btn {
                width: 43%;
                height: .7rem;
                line-height: .7rem;
                text-align: center;
                font-size: .26rem;
                border-radius: .12rem;

                &.cancel-btn {
                    border: .01rem solid $deposit-detail-cancel-border;
                    color: $deposit-detail-cancel-text;
                    background: $deposit-detail-cancel-bg;
                }

                &.confirm-btn {
                    background: $bg-component-gold-chip-color;
                    color: $deposit-detail-confirm-text;
                    font-weight: 700;
                }
            }
        }
    }

    &.mobile {
        // width: 100% !important;
        // height: 100% !important;

        .van-popup {
            &.van-popup--center {
                top: 16vh;
                bottom: 0;
                left: 0;
                transform: translate3d(0, 0, 0);
                width: 100% !important;
                // height: 100% !important;
            }
        }

        .content {
            width: 100% !important;
            height: 100% !important;
            max-height: 100%;
            border-radius: 12px 12px 0 0 !important;
        }
    }
}

.popup {
    .van-popup {
        background: transparent;

        .content {
            background:
                $deposit-detail-shell-highlight,
                $deposit-detail-shell-overlay,
                $bg-component-red-deep-gradient-color;
            border: 1px solid $deposit-detail-shell-border;
            box-shadow: $deposit-detail-shell-shadow;
            border-radius: .32rem;
        }

        .header {
            > div:first-child,
            .close {
                color: $font-color;
            }
        }

        .main-content {
            .WaitingForPayment,
            .money,
            .page_title {
                color: $font-color;
            }

            .money > span:last-child,
            .exchangeRate .val,
            .bills .bills-item > div:last-child .iconfont,
            .bills .bills-item > div:last-child .line {
                color: $deposit-detail-highlight;
            }

            .exchangeRate,
            .bills .bills-item > div,
            .tips {
                color: $deposit-detail-muted;
            }

            .bills {
                border-top: .01rem dashed $deposit-detail-muted-border;
                border-bottom: .01rem dashed $deposit-detail-muted-border;

                .bills-item {
                    &.qrcode-box {
                        border-top: .01rem dashed $deposit-detail-muted-border;
                    }

                    > div:last-child {
                        color: $font-color;
                    }
                }
            }

            .page_input {
                ::v-deep .ant-input {
                    background:
                        $deposit-detail-themed-input-overlay,
                        $bg-component-deep-color !important;
                    border-color: $deposit-detail-shell-border !important;
                    color: $font-color !important;
                }
            }
        }

        .btns {
            background: $deposit-detail-footer-bg;

            .btn {
                &.cancel-btn {
                    border-color: $deposit-detail-shell-border;
                    color: $font-color;
                    background: $deposit-detail-cancel-btn-bg;
                }

                &.confirm-btn {
                    background: $deposit-detail-confirm-btn-bg;
                    color: $font-color;
                    box-shadow: $deposit-detail-button-shadow;
                }
            }
        }
    }
}
</style>
